import { Check } from 'lucide-react';

export function ReservationSuccess() {
    return (
        <div className="flex flex-col items-center space-y-4 py-10">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
                <Check className="h-8 w-8 text-green-600" />
            </div>
            <h2 className="text-xl font-semibold">
                You'll get a confirmation via WhatsApp!
            </h2>
        </div>
    );
}
